precision highp float;

uniform float uTime;
uniform float uScrollOffset;
uniform vec2 uMousePos;
uniform float uHover;
uniform float uEntryProgress;
uniform float uIsMobile;

varying vec2 vUv;
varying float vDepth;

float hash(vec2 p) {
  return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123);
}

float noise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);

  return mix(
    mix(hash(i + vec2(0.0, 0.0)), hash(i + vec2(1.0, 0.0)), u.x),
    mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x),
    u.y
  );
}

vec3 applyHoverDeform(vec3 pos) {
  float isDesktop = 1.0 - clamp(uIsMobile, 0.0, 1.0);

  const float MAX_RADIUS = 0.45;
  const float BASE_STRENGTH = 0.85;
  const float FALL_POW = 1.6;
  const float PULSE_AMPL = 1.08;
  const float PULSE_SPEED = 6.0;

  vec2 centeredUv = vUv - vec2(0.5);
  vec2 local = centeredUv - uMousePos;
  float dist = length(local);

  float fall = 1.0 - smoothstep(0.0, MAX_RADIUS, dist);
  fall = pow(clamp(fall, 0.0, 1.0), FALL_POW);

  float hoverFactor = clamp(uHover, 0.0, 1.0);
  float strength = BASE_STRENGTH * hoverFactor * fall * isDesktop;
  float pulse = 1.0 + sin(uTime * PULSE_SPEED - dist * 12.0) * PULSE_AMPL * hoverFactor * fall;

  pos.z -= strength * pulse;
  return pos;
}

void main() {
  vUv = uv;
  vec3 pos = position;

#ifndef DISABLE_EFFECTS
  #ifdef USE_HORIZONTAL_ARC
    float strength = mix(0.15, 0.05, clamp(uIsMobile, 0.0, 1.0));
    float arc = (pos.y * pos.y) * uScrollOffset * strength;
    pos.x += arc;
  #endif

  float edgeThickness = 0.20;

  float topMask = smoothstep(0.0, edgeThickness, vUv.y);
  float bottomMask = 1.0 - smoothstep(1.0 - edgeThickness, 1.0, vUv.y);
  vDepth = 1.0 - (topMask * bottomMask);
#else
  vDepth = 0.0;
#endif

  pos = applyHoverDeform(pos);

  float entry = clamp(uEntryProgress, 0.0, 1.0);
  if (entry < 1.0) {
    float scale = mix(0.85, 1.0, smoothstep(0.0, 1.0, entry));
    pos.xy *= scale;
  }

  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}